export default function CoffeeCupIcon({
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fill="#303030"
        d="M16.717 1.977 15.63.144A.294.294 0 0 0 15.376 0H4.624c-.104 0-.2.055-.253.144L3.283 1.977a.294.294 0 0 0 .252.444h12.93a.294.294 0 0 0 .252-.444Z"
      />
      <path
        fill="#232323"
        d="M14.876 2.421h1.589a.294.294 0 0 0 .252-.444L15.63.144A.294.294 0 0 0 15.376 0H13.44l1.437 2.421Z"
      />
      <path
        fill="#E0E0E0"
        d="M16.684 3.805a.294.294 0 0 0-.22-.098H3.536a.294.294 0 0 0-.291.328l.375 3.252c.017.148.143.26.292.26h12.178c.15 0 .275-.112.292-.26l.375-3.252a.294.294 0 0 0-.072-.23Zm-1.5 10.985H4.816a.294.294 0 0 0-.292.328l.534 4.622c.017.148.143.26.292.26h9.302c.15 0 .275-.112.292-.26l.533-4.622a.293.293 0 0 0-.291-.328Z"
      />
      <path
        fill="#C6C6C6"
        d="M16.465 3.707h-1.377l-.443 3.84h1.444c.15 0 .275-.112.292-.26l.376-3.252a.294.294 0 0 0-.292-.328Zm-1.06 11.181a.294.294 0 0 0-.22-.098h-1.377L13.206 20h1.445c.15 0 .275-.112.292-.26l.534-4.622a.294.294 0 0 0-.073-.23Z"
      />
      <path
        fill="#494949"
        d="M17.266 1.833H2.734a.294.294 0 0 0-.294.294V4c0 .162.132.293.294.293h14.532a.294.294 0 0 0 .294-.293V2.127a.294.294 0 0 0-.294-.294Z"
      />
      <path
        fill="#303030"
        d="M17.266 1.833h-1.763v2.461h1.763a.294.294 0 0 0 .294-.293V2.127a.294.294 0 0 0-.294-.294Z"
      />
      <path
        fill="#FF9017"
        d="M16.998 7.057a.294.294 0 0 0-.22-.098H3.222a.294.294 0 0 0-.292.328l.904 7.83c.017.149.143.26.292.26h11.748c.15 0 .275-.111.292-.26l.904-7.83a.294.294 0 0 0-.072-.23Z"
      />
      <path
        fill="#ED7D0C"
        d="M16.998 7.057a.294.294 0 0 0-.22-.098h-1.377l-.972 8.419h1.445c.15 0 .275-.112.292-.26l.904-7.831a.294.294 0 0 0-.072-.23Z"
      />
      <path
        fill="#7C3D1E"
        d="M10 8.675c-1.094 0-1.985 1.055-1.985 2.353 0 1.297.89 2.353 1.985 2.353s1.984-1.056 1.984-2.353c0-1.298-.89-2.353-1.984-2.353Z"
      />
      <path
        fill="#602E18"
        d="M10 8.675c-.218 0-.428.042-.625.12.789.311 1.36 1.194 1.36 2.233 0 1.038-.571 1.921-1.36 2.232.197.078.407.12.625.12 1.094 0 1.985-1.055 1.985-2.352 0-1.298-.89-2.353-1.985-2.353Z"
      />
      <path
        fill="#472013"
        d="M10.734 8.843a1.71 1.71 0 0 0-.646-.165l-.1.107c0 .002-.002.003-.003.005-.384.435-.9 1.53-.11 2.558.215.278.266.617.154 1.007-.093.32-.263.554-.263.554l-.294.387a1.689 1.689 0 0 0 .68.077l.084-.11c.009-.013.227-.309.351-.724.174-.58.089-1.115-.246-1.55-.683-.887.037-1.755.084-1.81l.31-.336Z"
      />
    </svg>
  );
}
